import { LayoutComponents } from "@jelly/lesson";

import components100hz from "./dispersion/100-hz";
import components200hz from "./dispersion/200-hz";
import components350hz from "./dispersion/350-hz";
import components385hz from "./dispersion/385-hz";
import components450hz from "./dispersion/450-hz";
import components550hz from "./dispersion/550-hz";
import components650hz from "./dispersion/650-hz";
import components900hz from "./dispersion/900-hz";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "dependentSelect",
      options: {
        selects: [
          {
            id: "a",
            label: "Frequency",
            labelPosition: "top",
            options: [
              { value: "1", label: "100 Hz" },
              { value: "2", label: "200 Hz" },
              { value: "3", label: "350 Hz" },
              { value: "4", label: "385 Hz" },
              { value: "5", label: "450 Hz" },
              { value: "6", label: "550 Hz" },
              { value: "7", label: "650 Hz" },
              { value: "8", label: "900 Hz" },
            ],
          },
          {
            id: "b",
            label: "Mode selection",
            labelPosition: "top",
            options: [
              { value: "1", label: "(0,0)" },
              { value: "2", label: "(1,0)", allowedOnly: { a: ["2", "3", "4", "5", "6", "7", "8"] } },
              { value: "3", label: "(0,1)", allowedOnly: { a: ["3", "4", "5", "6", "7", "8"] } },
              { value: "4", label: "(2,0)", allowedOnly: { a: ["4", "5", "6", "7", "8"] } },
              { value: "5", label: "(1,1)", allowedOnly: { a: ["5", "6", "7", "8"] } },
              { value: "6", label: "(2,1)", allowedOnly: { a: ["6", "7", "8"] } },
              { value: "7", label: "(3,0)", allowedOnly: { a: ["7", "8"] } },
              { value: "8", label: "(3,1)", allowedOnly: { a: ["8"] } },
              { value: "9", label: "(0,2)", allowedOnly: { a: ["8"] } },
              { value: "10", label: "(1,2)", allowedOnly: { a: ["8"] } },
              { value: "11", label: "(4,0)", allowedOnly: { a: ["8"] } },
              { value: "12", label: "(2,2)", allowedOnly: { a: ["8"] } },
              { value: "13", label: "(4,1)", allowedOnly: { a: ["8"] } },
              { value: "14", label: "(3,2)", allowedOnly: { a: ["8"] } },
            ],
          },
        ],
        components: {
          ...components100hz,
          ...components200hz,
          ...components350hz,
          ...components385hz,
          ...components450hz,
          ...components550hz,
          ...components650hz,
          ...components900hz,
        },
      },
    },
  },
];

export default components;
